import React from "react";
import TextCellInfo from "./TextCellInfo";

interface Props {
  dataTest: string;
  lineOne?: string;
  lineTwo?: string;
}

export default ({ dataTest, lineOne, lineTwo }: Props) => {
  const lines = [
    <div key="lineOne" data-test={`${dataTest}-lineOne`}>
      {lineOne}
    </div>,
    <div key="lineTwo" data-test={`${dataTest}-lineTwo`}>
      {lineTwo}
    </div>,
  ];
  return <TextCellInfo dataTest={dataTest} text={lines} />;
};
